import { render, staticRenderFns } from "./EditableFormatSummaryTreeEditor.vue?vue&type=template&id=3950d350&scoped=true&"
import script from "./EditableFormatSummaryTreeEditor.vue?vue&type=script&lang=ts&"
export * from "./EditableFormatSummaryTreeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./EditableFormatSummaryTreeEditor.vue?vue&type=style&index=0&id=3950d350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3950d350",
  null
  
)

export default component.exports